const guard = {
    invalid_input: 'Запрос {{type}} неверный.',
    invalid_pagination: 'Значение разбиения на страницы неверно.',
    can_not_get_tenant_id: 'Невозможно получить идентификатор арендатора из запроса.',
    file_size_exceeded: 'Превышен размер файла.',
    mime_type_not_allowed: 'MIME-тип не разрешен.',
};
export default guard;
